import { BaseChannel } from "@app/channels/base_channel";

export class DebuggingChannel extends BaseChannel {
  connected(){
    super.connected();
  }

  received(payload){
    super.received(payload);
  }

  consoleLog(payload){
    console.log(payload);
  }

  alert(payload){
    alert(JSON.stringify(payload));
  }

  get permittedPayload() {
    return {};
  }
}
